module.exports = __webpack_public_path__ + "fonts/gotham_medium.a52599f.otf";